import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatLabel = createCustomElementWrapper('kat-label', 'KatLabel', {
    'tooltipPosition': 'tooltip-position',
    'tooltipText': 'tooltip-text',
    'tooltipTriggerIcon': 'tooltip-trigger-icon',
    'uniqueId': 'unique-id',
}, {});
